import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const LearningModal = ({ open, onClose }) => {
  const handleSave = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: "primary.main", fontWeight: 700 }}
        >
          Hamidabai Abdulaboobaker&apos;s Funding Profile
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Box component="form">
        <DialogContent dividers>
          <Grid container spacing={2}>
            {/* Improvement Area */}
            <Grid size={{ xs: 12 }}>
              <TextField
                select
                fullWidth
                label="Improvement Area*"
                defaultValue=""
                size="small"
              >
                <MenuItem value="">Select Service</MenuItem>
                <MenuItem value="">Select Service</MenuItem>
              </TextField>
            </Grid>

            {/* Issue */}
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Issue*"
                name="issue"
                placeholder="Enter your message here"
                size="small"
              />
            </Grid>

            {/* Action Taken */}
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Action Taken*"
                name="taken"
                placeholder="Enter your message here"
                size="small"
              />
            </Grid>

            {/* Action + Date Required */}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                select
                fullWidth
                label="Action"
                defaultValue=""
                size="small"
              >
                <MenuItem value="">Select Service</MenuItem>
                <MenuItem value="">Select Service</MenuItem>
              </TextField>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                type="datetime-local"
                label="Date Required"
                name="dateTime"
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>

            {/* Outcome */}
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Outcome"
                name="outcome"
                placeholder="Enter your message here"
                size="small"
              />
            </Grid>

            {/* Status */}
            <Grid size={{ xs: 12 }}>
              <TextField
                select
                fullWidth
                label="Status"
                defaultValue=""
                size="small"
              >
                <MenuItem value="">Select Service</MenuItem>
                <MenuItem value="">Select Service</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            sx={{ mr: 1 }}
          >
            Close
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default LearningModal;